import React, { useState, useRef, useContext } from 'react';
import AuthContext from '../context/AuthContext';
import { useBreakpoint } from 'gatsby-plugin-breakpoints';
import styled from 'styled-components';
import { injectIntl, FormattedHTMLMessage } from 'gatsby-plugin-intl';
import { device } from "../device";

import LogoutBtn from '../styledComponents/LogoutBtn';

import { LanguageSwitcherDesk } from './LanguageSwitcher'
import Burger from './Burger'
import Menu from './Menu'

const Bar = styled.header`
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 1000;
`;
const HeaderContainer = styled.div`
    display: flex;
    align-items: center;
    height: 56px;
    padding: 0 16px;
    position: relative;
    width: 100%;
    z-index: 1000;
    background: var(--light-gray1);
    transition: background .3s ease;
    .dark & {
        background: #000;
        color: #fff;
    }
    @media ${device.lg} {
        padding: 0 24px;
    }
`;
const LogoLink = styled.button`
    display: flex;
    align-items: center;
    height: 40px;
    padding: 0;

    background: transparent;
    border: none;
    cursor: pointer;
    outline: none;
    &:hover,
    &:focus {
        color: var(--brand);
    }
`;

const Logo = styled.svg`
    width: 76px;

    fill: var(--brand1);

    transition: fill .3s ease;
    .dark & {
        fill: #fff;
    }
`;
const LogoText = styled.h1`
    position: relative;

    margin: 0 0 0 36px;

    font-size: 16px;
    font-weight: 400;
    line-height: 24px;

    transition: color .3s ease;
    .dark & {
        color: #fff;
    }
    &:after {
        left: -15px;
        top: 0;
        position: absolute;

        content: '';
        height: 24px;
        width: 1px;

        background: var(--midle-gray1);
    }   
`;
const LoginContainer = styled.div`
    align-items: center;
    display: flex;
    margin-left: auto;
    margin-right: 32px;
`;
const HelpBlock = styled.div`
    color: var(--brand);
    font-size: 12px;
    line-height: 16px;
    margin-right: 32px;
    transition: color .15s ease-in-out;
    will-change: color;
    a {
        color: var(--brand);
        text-decoration: underline;
        transition: color .15s ease-in-out;
        will-change: color;
    }
    .dark & {
        color: var(--light-gray3);
        a {
            color: var(--light-gray3);
        }
    }
`;

const Header = ({ intl, refs, handleCLick }) => {

    const breakpoints = useBreakpoint();

    const [openNav, setOpenNav] = useState(false);
    const menuId = "main-menu";

    const authcontext = useContext(AuthContext);

    const node = useRef();
    return (
        <Bar id="pageHeader" className="dark" ref={node}>
            <HeaderContainer>
                <LogoLink onClick={() => handleCLick('firstScreen')}>
                    <Logo xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 20" role="img" aria-label="Ajax Systems"><path d="M74.69.88h-5.3l21.25 19.11h5.3L74.69.88M80.83 14.48l-6.13 5.51h-5.3l6.12-5.51h5.31M89.82 6.39L95.95.88h-5.3l-6.13 5.51h5.3M13.28.88l-2.17 3.11 11.07 16h4.38L13.28.88M7.66 8.97H12L4.38 19.99H0L7.66 8.97M53.24.88l-2.17 3.11 11.07 16h4.38L53.24.88M47.62 8.97h4.34l-7.62 11.02h-4.38l7.66-11.02M35.23.88l.01 11.7c-.01 1.9-.9 4.27-3.89 4.47h-1.09v2.94s.95 0 1.57.01c1.44.02 3.52-.68 4.81-2.06 1.81-1.92 2.03-4.37 2.03-5.55V.88h-3.44"/></Logo>
                    <LogoText>Brand Guidelines</LogoText>
                </LogoLink>
                {breakpoints.lg &&
                    <LoginContainer>
                        {authcontext.data.loginMode 
                        ? 
                            <>
                                <HelpBlock><FormattedHTMLMessage id="help_text" /></HelpBlock>
                                <AuthContext.Consumer>
                                    {({updateLoginMode}) => (
                                    <LogoutBtn onClick={updateLoginMode}>
                                        {intl.formatMessage({ id: 'logout_btn' })}
                                    </LogoutBtn>
                                    )}
                                </AuthContext.Consumer>
                            </>
                            : 
                            <>
                                {/* <ModalContext.Consumer>
                                    {({updateModalMode}) => (
                                    <LoginBtn onClick={updateModalMode}>
                                        {intl.formatMessage({ id: 'login_btn' })}
                                    </LoginBtn>
                                    )}
                                </ModalContext.Consumer> */}
                            </>
                        }
                    </LoginContainer>
                }
                <LanguageSwitcherDesk />
                <Burger openNav={openNav} setOpenNav={setOpenNav} aria-controls={menuId} />
            </HeaderContainer>
            <Menu openNav={openNav} setOpenNav={setOpenNav} id={menuId} refs={refs} handleCLick={handleCLick} />
        </Bar>
    );
};

export default injectIntl(Header);
